import { Avatar, Grid, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../configs/colors';
import { Box } from '../../atoms/Box';

export const SLAContactBox = styled(Box)`
  width: 100%;
  border: 0px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  box-sizing: border-box;
  margin-bottom: 0px;
  padding-top: 2px;
`;

export const ContactGridContainer = styled(Grid)`
  margin-bottom: 10px;
`;

export const LetterAvatar = styled(Avatar)`
  background-color: ${COLORS.SLAComplete};
  color: white;
  border-style: solid;
  border-width: 2px;
  height: 20px;
  width: 20px;
  margin-top: 3px;
  margin-left: 5px;
`;

export const ReviewedLetterAvatar = styled(Avatar)`
  background-color: ${COLORS.SLABreached};
  color: white;
  border-style: solid;
  border-width: 2px;
  height: 20px;
  width: 20px;
  margin-top: 3px;
  margin-left: 5px;
`;

export const GridInnerWrapper = styled(Stack)`
  margin-left: 8px;
  padding-top: 2px;
  padding-right: 10px;
`;
